import { DropdownField, Tag } from '@highmobility/console-ui-components';
import { FC, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { CreateTeamDialog } from '@/components/organisms/CreateTeamDialog';
import { ROUTE_PATHS } from '@/router/routes';
import { useMobx } from '@/hooks/useMobx';

export type TeamsSelectProps = {
  onSelect: (teamId: string) => void;
};

export const TeamsSelect: FC<TeamsSelectProps> = observer((props) => {
  const { teams } = useMobx();
  const [showCreateTeamDialog, setShowCreateTeamDialog] = useState(false);
  const navigate = useNavigate();

  const teamsSelectItems = useMemo(() => {
    const teamItems = teams.sortedList.map((team, i) => ({
      label: (
        <div className="flex items-center gap-2">
          <span>{team.name}</span>
          {team.is_default && (
            <Tag className="-my-[2px]" type="light">
              Default
            </Tag>
          )}
        </div>
      ),
      value: team.id,
      onClick: () => props.onSelect(team.id),
      thickSeparator: teams.sortedList.length - 1 === i,
    }));

    return [
      ...teamItems,
      {
        label: 'Create a new team',
        onClick: () => setShowCreateTeamDialog(true),
      },
      {
        label: 'Manage teams',
        onClick: () => {
          navigate(ROUTE_PATHS.TEAMS);
        },
      },
    ];
  }, [props, navigate, teams.sortedList]);

  return (
    <>
      <DropdownField
        className="min-w-[320px]"
        name="team"
        placeholder="Select team"
        items={teamsSelectItems}
        value={teams.activeTeam?.id}
      />
      <CreateTeamDialog isOpen={showCreateTeamDialog} setIsOpen={setShowCreateTeamDialog} />
    </>
  );
});
